export const getWalletBalance = ({
  hasWalletBalances,
  totalWalletApplicableOrderAmount,
  usableAmountInWallet,
}) => {
  if (hasWalletBalances) {
    if (totalWalletApplicableOrderAmount <= usableAmountInWallet)
      return totalWalletApplicableOrderAmount;

    return usableAmountInWallet;
  }

  return 0;
};
export const getWalletTotalBalance = ({
  currency,
  hasWalletBalances,
  walletBalances,
}) => {
  if (hasWalletBalances) {
    return walletBalances[currency].totalBalance;
  }

  return 0;
};

export const isShowCredit = ({
  hasCreditInSameCurrency,
  isWalletAllowed,
  totalWalletApplicableOrderAmount,
  walletHasRefundableBalance,
}) => {
  return Boolean(
    ((isWalletAllowed && hasCreditInSameCurrency) ||
      walletHasRefundableBalance) &&
      totalWalletApplicableOrderAmount,
  );
};

const notEligibleMarketingBalance = ({
  currency,
  isWalletAllowed,
  promoCodeIsApplied,
  totalWalletApplicableOrderAmount,
  usableAmountInWallet,
  walletBalances,
}) => {
  return (
    walletBalances &&
    walletBalances[currency].marketingBalance &&
    (!isWalletAllowed || promoCodeIsApplied) &&
    usableAmountInWallet <= totalWalletApplicableOrderAmount
  );
};

const notEligibleRefundableBalance = ({
  currency,
  promoCodeIsApplied,
  walletBalances,
}) => {
  return promoCodeIsApplied && !walletBalances[currency].refundableBalance;
};

export const setUpWalletBalances = ({ paymentOptions }) => {
  const userWallets = {};
  if (!paymentOptions) return userWallets;
  paymentOptions.creditBalances.forEach((wallet) => {
    userWallets[wallet.currency.toLowerCase()] = {
      marketingBalance: wallet.marketingBalance,
      refundableBalance: wallet.refundableBalance,
      totalBalance: wallet.balance,
    };
  });

  return userWallets;
};

const usableWallet = ({
  currency,
  isWalletAllowed,
  promoCodeIsApplied,
  walletBalances,
}) => {
  // we can use only refundable balance if the deal is not applicable or we are using promo codes
  if (
    (!isWalletAllowed || promoCodeIsApplied) &&
    walletBalances[currency].refundableBalance
  ) {
    return walletBalances[currency].refundableBalance;
  }

  return false;
};

export const notEligibleForAnyWallet = ({
  currency,
  hasWalletBalances,
  isWalletAllowed,
  promoCodeIsApplied,
  totalWalletApplicableOrderAmount,
  usableAmountInWallet,
  walletBalances,
}) => {
  if (!hasWalletBalances) return false;

  return (
    notEligibleRefundableBalance({
      currency,
      promoCodeIsApplied,
      walletBalances,
    }) &&
    notEligibleMarketingBalance({
      currency,
      isWalletAllowed,
      promoCodeIsApplied,
      totalWalletApplicableOrderAmount,
      usableAmountInWallet,
      walletBalances,
    })
  );
};

export const hasError = ({
  currency,
  hasWalletBalances,
  isWalletAllowed,
  promoCodeIsApplied,
  totalWalletApplicableOrderAmount,
  usableAmountInWallet,
  walletBalances,
}) => {
  if (!hasWalletBalances) return false;

  return (
    notEligibleRefundableBalance({
      currency,
      promoCodeIsApplied,
      walletBalances,
    }) ||
    notEligibleMarketingBalance({
      currency,
      isWalletAllowed,
      promoCodeIsApplied,
      totalWalletApplicableOrderAmount,
      usableAmountInWallet,
      walletBalances,
    })
  );
};

export const getUsableWalletBalance = ({
  amountInWallet,
  currency,
  hasWalletBalances,
  isWalletAllowed,
  promoCodeIsApplied,
  walletBalances,
}) => {
  if (hasWalletBalances) {
    return (
      usableWallet({
        currency,
        isWalletAllowed,
        promoCodeIsApplied,
        walletBalances,
      }) || amountInWallet
    );
  }

  return 0;
};
